import React from "react"

import { Element, Image } from "legacy/components/shared/base"
import Link from "legacy/components/shared/Link"
import { Maybe } from "types/Maybe"
import { PrismicImageType } from "types/__generated__/gatsby-graphql"

interface OwnProps {
  logo: Maybe<PrismicImageType>
}

export type HeaderLogoProps = OwnProps

const HeaderLogo: React.FC<HeaderLogoProps> = ({
  logo,
}): React.ReactElement | null => {
  if (!logo?.alt || !logo?.url) return null
  return (
    <Element>
      <Link to="/">
        <Image
          imageData={logo}
          style={{ display: "block" }}
          height={[19, 29]}
          width={[100, 150]}
        />
      </Link>
    </Element>
  )
}

export default HeaderLogo
